//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props: {
        classname: String,
        title_tip: String,
        show_desc: Boolean,
        apartment_counts: Array,
        current_house: Object
    },
    computed: {
        classes() {
            const { is_ln_fusing } = this.current_house
            let default_class = 'house-count-wrap'
            if (this.classname) {
                default_class += ` ${this.classname}`
            }
            if (is_ln_fusing) {
                default_class +=  ` fusing`
            }
            return default_class
        },
        has_candidate(){
            return this.apartment_counts && this.apartment_counts.length && this.apartment_counts[0].includes('普通递补')
        }
    },
    methods: {
        onFusing() {
            window.location.href = 'https://mp.weixin.qq.com/s/gSHTknGSS936GXSvJST-UQ'
        },
        goExplain(){
            window.location.href = 'https://mp.weixin.qq.com/s/T2ev25Xbxa1i1hZRWRAilg'
        }
    }
}
